import React from "react";
import ViewConfig from "../../../tsx/config/ViewConfig";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import {getManager} from "../Manager";
import {IActivatedViews, IRouteProps, IChoiceViewConfig, IViewProps} from "./ViewInterface";

export default class ViewManager
{
    viewConfig:ViewConfig;

    constructor(viewConfig:ViewConfig)
    {
        this.viewConfig = viewConfig;
    }

    getChoiceViewConfig (choice: RouteChoice, isHidden?:boolean, activatedMainViews?:IActivatedViews|null, withProps?:IViewProps|null): IChoiceViewConfig
    {
        const path = choice.getHref();
        const props: IRouteProps = {
            choice: choice,
            titleAreaKey: "title-area-" + path,
            mainViewKey: "main-view-" + path,
            isSecondaryRoute: this.isSecondaryChoiceRoute(choice),
            componentModel: withProps?.componentModel,
            interfaceModel: withProps?.interfaceModel
        };

        let mainView: React.JSX.Element | null = this.viewConfig.getOverrideView(props);
        let isOverrideView: boolean = false;
        if (mainView)
        {
            isOverrideView = true;
            if (activatedMainViews)
            {
                delete activatedMainViews[choice.realPath];
            }
        }

        if (!mainView)
        {
            mainView = activatedMainViews ? (activatedMainViews[choice.realPath] ?? null) : null;
        }

        if (!mainView)
        {
            mainView = isHidden ? this.viewConfig.getEmptyView() : null;
        }

        if (!mainView)
        {
            mainView = this.viewConfig.getMainView(props);
            if (!mainView)
            {
                mainView = this.viewConfig.getDefaultView(props);
            }
            if (activatedMainViews)
            {
                activatedMainViews[choice.realPath] = mainView;
            }
        }

        return {
            props: props,
            titleArea: this.viewConfig.getTitleAreaView(props),
            mainView: mainView,
            modalView: this.viewConfig.getModalView(props),
            isOverrideView: isOverrideView,
        }
    }

    getPrimaryChoiceViewConfig = (): IChoiceViewConfig|null =>
    {
        const primaryChoice = getManager().navigation.model.primaryChoice;
        return primaryChoice ? this.getChoiceViewConfig(primaryChoice) : null;
    }

    isSecondaryChoiceRoute (choice:RouteChoice): boolean
    {
        return this.viewConfig.isSecondaryRoute(choice)
    }

    isModalChoiceRoute (choice:RouteChoice): boolean
    {
        return this.viewConfig.isSecondaryRoute(choice)
    }
}